import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { RepresentanteSituacaoMultiselectModule } from '../situacao/multiselect';
import { EstadoMultiselectModule } from '../../../estado/multiselect';
import { CidadeModule } from '../../../cidade';
import { RepresentanteFilterModalComponent } from './modal';
import { RepresentanteFilterComponent } from './representante-filter.component';
import { ClassificacaoTipoMultiselectModule } from '../../../classificacao/tipo/multiselect';
import { RepresentanteModalidadeComercialMultiselectModule } from '../components/modalidade-comercial/multiselect';

@NgModule({
    imports: [
        SharedModule,
        RepresentanteSituacaoMultiselectModule,
        EstadoMultiselectModule,
        CidadeModule,
        ClassificacaoTipoMultiselectModule,
        RepresentanteModalidadeComercialMultiselectModule
    ],
    declarations: [
        RepresentanteFilterModalComponent,
        RepresentanteFilterComponent
    ],
    exports: [
        RepresentanteFilterModalComponent,
        RepresentanteFilterComponent
    ]
})
export class RepresentanteFilterModule { }
